import React, { Component } from 'react';
import { Button, Form, Input, FormGroup, FormFeedback, Col, Card, CardBody } from 'reactstrap';
import './style.scss';
import { setUserSignUp } from "./helper";
import { signUp, logout, setUserDetails } from "./action";
import { connect } from 'react-redux';
import Modal from '../../../components/UI/Modal/Modal';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';

class CreateAnalystsComponent extends Component {

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.enviornment = process.env.NODE_ENV;
        this.initialState = {
            welcome: 'Welcome to Rubix',
            firstname: '',
            lastname: '',
            email: '',
            formErrors: { firstname: '', lastname: '', email: '' },
            firstNameValid: false,
            lastNameValid: false,
            emailValid: false,
            formValid: false,
            isCorporate: false,
            loggedIn: false,
            showModal: false,
            modalBody: ""
        }

        this.state = this.initialState;
    }
    componentDidMount() {
        setPageView('/Analyst/Create', document.location.href)
    }
    handleToggleModal = () => {
        this.setState({ ...this.initialState, showModal: !this.state.showModal })

    }

    componentDidUpdate(prevProps) {
        if (this.props.signUpSuccess !== prevProps.signUpSuccess) {
            goolgeAnalyticsEvents('Admin', 'Onboard Analyst', 'Create Analyst', '')
            let modalJSX = (
                <div className="modal-body">
                    <p>{this.props.signUpSuccess.message}</p>
                    <Button color="primary" type="button" onClick={this.handleToggleModal}>Ok</Button>
                </div>
            );
            this.setState({ ...this.initialState, showModal: !this.state.showModal, modalBody: modalJSX })
        }
        if (this.props.signUpFailure !== prevProps.signUpFailure) {
            let modalJSX = (
                <div className="modal-body">
                    <p>{(this.props.signUpFailure.response && this.props.signUpFailure.response.data) ? this.props.signUpFailure.response.data.message : "Something went wrong! Please try again."}</p>
                    <Button color="primary" type="button" onClick={this.handleToggleModal}>Ok</Button>
                </div>
            );
            this.setState({ ...this.initialState, showModal: !this.state.showModal, modalBody: modalJSX })
        }
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let firstNameValid = this.state.firstNameValid;
        let lastNameValid = this.state.lastNameValid;
        let emailValid = this.state.emailValid;
        let validInput=value.match(/^[^<>!$%^?*~`{}=]*$/);
        var errorMsg=''
        let generalInValidErrorMsg='Please enter a valid input';
        switch (fieldName) {
            case 'firstname':
                firstNameValid = value.length > 0 && validInput;
                errorMsg=!validInput?generalInValidErrorMsg:'First name cannot be empty';
                fieldValidationErrors.firstname = firstNameValid ? '' : errorMsg;
                break;
            case 'lastname':
                lastNameValid = value.length > 0 && validInput;
                errorMsg=!validInput?generalInValidErrorMsg:'Last name cannot be empty';
                fieldValidationErrors.lastname = lastNameValid ? '' : errorMsg;
                break;
            case 'email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && validInput;
                errorMsg=!validInput?generalInValidErrorMsg:'Email id is not in proper format';
                fieldValidationErrors.email = emailValid ? '' : errorMsg;
                break;
            default:
                break;
        }

        this.setState({
            formErrors: fieldValidationErrors,
            firstNameValid: firstNameValid,
            lastNameValid: lastNameValid,
            emailValid: emailValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.firstNameValid && this.state.lastNameValid && this.state.emailValid });
    }

    errorClass(error) {
        return (error.length === 0 ? 'No Error' : 'has-error');
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => { this.validateField(name, value) });
    }

    submitButton = (event) => {
        event.preventDefault();
        const userSignUp = setUserSignUp(this.state.firstname, this.state.lastname, this.state.email)
        this.props.signUp(userSignUp);
        //event.target.reset();
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Add Analyst</h4>
                </div>
                <Card className="mb-70">
                    <CardBody>
                        <Form className="w-50" id="addAnalystForm" onSubmit={this.submitButton} ref={this.formRef}>
                            <FormGroup className="mb-4">
                                <Input value={this.state.firstname} type="text" name="firstname" id="firstname" placeholder="First Name" className={this.state.formErrors.firstname ? 'is-invalid' : ''} onChange={this.handleUserInput} required />
                                <FormFeedback className="text-left">{this.state.formErrors.firstname}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="mb-4">
                                <Input value={this.state.lastname} type="text" name="lastname" id="lastname" placeholder="Last Name" className={this.state.formErrors.lastname ? 'is-invalid' : ''} onChange={this.handleUserInput} required />
                                <FormFeedback className="text-left">{this.state.formErrors.lastname}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="mb-4">
                                <Input value={this.state.email} type="email" name="email" id="email" placeholder="Email Id" className={this.state.formErrors.email ? 'is-invalid' : ''} onChange={this.handleUserInput} required />
                                <FormFeedback className="text-left">{this.state.formErrors.email}</FormFeedback>
                            </FormGroup>
                            <FormGroup className="text-right">
                                <Button size="lg" name="btn-login" color="primary" type="submit" className="" disabled={!this.state.formValid}>ADD</Button>
                            </FormGroup>
                        </Form>
                    </CardBody>
                    <Modal show={this.state.showModal} className="Modal" modalClosed={this.handleToggleModal}>{this.state.modalBody}</Modal>
                </Card>
            </Col>


        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    //signUpSuccess: state.loginDetails.loginSuccess,
    //userDetails: state.loginDetails.userDetails
    signUpSuccess: state.signUpDetails.signUpSuccess,
    signUpFailure: state.signUpDetails.signUpFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    signUp: (data) => { dispatch(signUp(data)) },
    setUserDetails: (data) => { dispatch(setUserDetails(data)) },
    logout: () => { dispatch(logout()) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateAnalystsComponent);
